<template>
    <div
        class="m-case-study--list"
    >
        <y-loading
            v-if="!heroData"
            :active="$wait.is('loading-case-study')"
            size="60"
            height="467px"
            position="relative"
        />
        <div class="m-case-study--list__hero-wrapper">
            <y-container>
                <y-hero
                    v-if="heroData"
                    :hero-data="heroData"
                    class="m-case-study--list__hero"
                />
            </y-container>
        </div>
        
        <div class="m-case-study--list__cases-list">
            <y-container>
                <y-popular-client
                    v-if="heroData"
                    :popular-data="heroData"
                />
            </y-container>
        </div>

        <div class="m-case-study--list__cards">
            <y-container>
                <y-cases
                    v-if="categories && caseStudyData"
                    :categories="categories"
                    :cases="caseStudyData"
                    :button-data="heroData.custom"
                />
            </y-container>
        </div>

        <div class="m-case-study--list__cta">
            <y-container>
                <y-banner :content="heroData" />
            </y-container>
        </div>
    </div>
</template>

<script>
    import YHero from '@modules/case-studies/components/Hero/Hero.vue';
    import YPopularClient from '@modules/case-studies/components/PopularClient/PopularClient.vue';
    import YCases from '@modules/case-studies/components/Cases/Cases.vue';
    import YBanner from '@modules/case-studies/components/Banner/Banner.vue';

    export default {
        name: 'CaseStudiesList',

        components: {
            YHero,
            YPopularClient,
            YCases,
            YBanner,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                caseStudyData: null,
                heroData     : null,
                heroContent  : '',
                categories   : null,
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        /**
         * @inheritDoc
         */
        created() {
            this.$wait.end('loading-page');
            this.getAllCases();
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            /**
             * Check the Promise.all Request Error
             * 
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },
        
            /**
             * Fetch case studies data
             *
             * @returns {Promise}
             */
            getAllCases() {
                this.$wait.start('loading-case-study');
                const caseStudy = this.$services.Content.postList({
                    type     : 'case-studies',
                    including: ['title', 'synopsis', 'image', 'custom', 'url_encode', 'tagging_cats', 'slug'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const hero = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'case-studies',
                    locale   : this.$i18n.locale,
                    including: ['image', 'title', 'custom', 'title2', 'seo_canonical', 'seo_meta_description', 'seo_post_title', 'albums'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const categories = this.$services.Tagging.labels({
                    slug     : 'case-studies-category',
                    locale   : this.$i18n.locale,
                    including: ['title', 'slug', 'url_encode'],
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([caseStudy, hero, categories]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.caseStudyData = responses[0].data.results;
                    }

                    if (this.handleReq(responses, 1)) {
                        this.heroData = responses[1].data.results;
                        this.heroContent = this.heroData;
                    }

                    if (this.handleReq(responses, 2)) {
                        this.categories = responses[2].data.results;
                        this.categories = [{ slug: 'all_categories', id: 'all_categories', title: this.$t('category.categories') }, ...this.categories];
                    }
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('loading-case-study');
                });
            },
        },
    };
</script>

<style lang="scss" src="../scss/case-studies.scss" />
